module.exports = __webpack_public_path__ + "fonts/fa-brands-400.23f19bb.eot";